import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  fulfillmentCapabilitiesTitle: {
    defaultMessage: '1. Fulfillment Capabilities',
    description: 'Title for the fulfillment capabilities section',
    id: 'KVDGs6',
  },
  fulfillmentCapabilitiesDescription: {
    defaultMessage: 'Which of the following fulfillment capabilities do you require, if any?',
    description: 'Description for the fulfillment capabilities section',
    id: 'JNpd+R',
  },
  selectAllThatApply: {
    defaultMessage: '(Select all that apply)',
    description: 'Instructions for the fulfillment capabilities selection section',
    id: 'c64W7k',
  },
  specialKittingBundling: {
    defaultMessage: 'Special Kitting/Bundling',
    description: 'Fulfillment capability option',
    id: '7PSNuU',
  },
  serialNumberSupport: {
    defaultMessage: 'Serial Number Support',
    description: 'Fulfillment capability option',
    id: 'qtcDkp',
  },
  hazardousGoods: {
    defaultMessage: 'Hazardous Goods',
    description: 'Fulfillment capability option',
    id: '8Obj6F',
  },
  coldStorage: {
    defaultMessage: 'Cold Storage',
    description: 'Fulfillment capability option',
    id: 'IKPqYM',
  },
  lotsExpirationDates: {
    defaultMessage: 'Lots/Expiration Dates',
    description: 'Fulfillment capability option',
    id: 'Tc+PHs',
  },
  heavyItems: {
    defaultMessage: 'Heavy Items (more than 50lbs)',
    description: 'Fulfillment capability option',
    id: 's3XJXR',
  },
  fragileItems: {
    defaultMessage: 'Fragile Items',
    description: 'Fulfillment capability option',
    id: '/ES1vI',
  },
  largeItems: {
    defaultMessage: 'Large Items (bigger than 4ft in any dimension)',
    description: 'Fulfillment capability option',
    id: 'nlR+rO',
  },
  moreDetails: {
    defaultMessage: 'Please provide more details on these selected capabilities:',
    description: 'Label for text area to provide more details on selected capabilities',
    id: '+lJ5vC',
  },
});
